(function()
{
    //Import classes
    var BasePanel = include('springroll.easeljs.BasePanel'),
		Container = include('createjs.Container'),
        Bitmap = include('createjs.Bitmap'),
        Sprite = include('createjs.Sprite'), 
        Fish = include('WGBH.Fish'),
        AccButton = include('WGBH.AccButton');

    /**
     * Panel contains all of the visual elements for the title state
     * @class WGBH.SuccessPanel
     * @extends springroll.easeljs.BasePanel
     */
    var SuccessPanel = function()
    {
        BasePanel.call(this);
    };

    //Super prototype
    var s = BasePanel.prototype;

    //Extend the base panel
    var p = extend(SuccessPanel, BasePanel);

    /**
     * Setup the state, this happens on each state entering
     */
    p.setup = function()
    {
		var buildarr = [],
			len = 0,
			ctr = 0,
			anim_params,
			fr_sel;		
		// add backgrounds
		this.successbg = new Bitmap(images.successbg);
        this.successbg.x = app.config.GAME.SUCCESS.bg.x;
        this.successbg.y = app.config.GAME.SUCCESS.bg.y;
		this.addChild(this.successbg);

		// add animation display container
		this.animdisp = new Container();
		this.addChild(this.animdisp);
		
		// add plants
		buildarr = app.config.GAME.ANIM.winplants;
		len = buildarr.length;
		ctr = 0;
		for(; ctr < len; ++ctr) {
			anim_params = buildarr[ctr];
			// make sure there's enough values to pick from
			if(app.plant_frames.length === 0) {
				app.plant_frames = app.config.GAME.ANIM.plant_fr.slice(0);
			}
			fr_sel = 'anim' + app.plant_frames.splice(getRandomWholeNumber(0, app.plant_frames.length - 1), 1);
			this.anim_spr = new Sprite(LOADED_OBJECTS.sprsheets.plant_spr, fr_sel);
			this.anim_spr.scaleX = this.anim_spr.scaleY = anim_params.sc;
			this.anim_spr.x = anim_params.x;
			this.anim_spr.y = anim_params.y;
			this.anim_spr.play();
			this.animdisp.addChild(this.anim_spr);
		}
		// add grass
		buildarr = app.config.GAME.ANIM.wingrass;
		len = buildarr.length;
		ctr = 0;
		for(; ctr < len; ++ctr) {
			anim_params = buildarr[ctr];
			// make sure there's enough values to pick from
			if(app.grass_frames.length === 0) {
				app.grass_frames = app.config.GAME.ANIM.grass_fr.slice(0);
			}
			fr_sel = 'anim' + app.grass_frames.splice(getRandomWholeNumber(0, app.grass_frames.length - 1), 1);
			this.anim_spr = new Sprite(LOADED_OBJECTS.sprsheets.grass_spr, fr_sel);
			this.anim_spr.scaleX = this.anim_spr.scaleY = anim_params.sc;
			this.anim_spr.x = anim_params.x;
			this.anim_spr.y = anim_params.y;
			this.anim_spr.play();
			this.animdisp.addChild(this.anim_spr);
		}
				
		// add fish
		this.fishobj = new Fish(app.correct_answer, 0, false);
		this.fishobj.view.x = app.config.GAME.SUCCESS.fish.x;
		this.fishobj.view.y = app.config.GAME.SUCCESS.fish.y;
		this.fishobj.view.scaleX = this.fishobj.view.scaleY = app.config.GAME.SUCCESS.fish.scaling;
		this.addChild(this.fishobj.view);
		
		// add button
        this.playagainbt = new AccButton(
        				'playagainbt', 
        				LOADED_OBJECTS.sprsheets.graphics_spr,
        				'_playagainbt_on',
        				app.config.GAME.SUCCESS.playbt.x,
        				app.config.GAME.SUCCESS.playbt.y, 
        				app.config.GAME.SUCCESS.playbt.wid, 
        				app.config.GAME.SUCCESS.playbt.hgt,
        				app.config.GAME.SUCCESS.playbt.label,
        				true
        				);
		this.addChild(this.playagainbt.view);

		// add selection bg
		this.selectbg = new Bitmap(images.selectionbg);
        this.selectbg.x = app.config.GAME.GAMEPLAY.selectbg.x;
        this.selectbg.y = app.config.GAME.GAMEPLAY.selectbg.y;
		this.addChild(this.selectbg);

		// add ui display container
		this.uidisp = new Container();
		this.addChild(this.uidisp);

		// add regular game border
        this.titleframe = new Bitmap(images.title_frame);
        this.titleframe.x = app.config.GAME.FRAME.x;
        this.titleframe.y = app.config.GAME.FRAME.y;
		this.addChild(this.titleframe);
		
		buildarr = null;
		anim_params = null;
    };

    /**
     * Un-setup the panel when exiting the state
     */
    p.teardown = function()
    {
		this.fishobj.clearObject();
		// stop other animations
		while(this.animdisp.numChildren > 0 ) {
			this.anim_spr = this.animdisp.getChildAt(0);
			this.anim_spr.stop();
			this.animdisp.removeChildAt(0);	
			this.anim_spr = null;					
		}
        s.teardown.call(this);
        this.fishobj = null;
        this.animdisp = null;
        this.successbg = null;
		this.selectbg = null;
        this.titleframe = null;
		this.uidisp = null;
    };

    //Assign to namespace
    namespace('WGBH').SuccessPanel = SuccessPanel;
}());